import {useEffect, useState} from 'react';
import {ChangeHandler} from '../../types/Handler';
import Dropdown, {DropdownOptionType} from './Dropdown';

export type CountrySelectProps = {
    id: string,
    label: string
    value?: string,
    errorMessage?: string,
    required?: boolean,
    tabIndex?: string,
    language?: string,
    onChange?: ChangeHandler,

};

const arrayToString = (data: string[] | string): string => {
    if (Array.isArray(data)) {
        return data[0];
    }

    return data;
};

const CountrySelect = (props: CountrySelectProps) => {
    const [options, setOptions] = useState<DropdownOptionType[]>();

    if (!options) {
        const countryData = require(`i18n-iso-countries/langs/${props.language}.json`);

        const option = Object.keys(countryData.countries).map(c => {
            const mapped: DropdownOptionType = {
                value: c,
                label: arrayToString(countryData.countries[c])
            };

            return mapped;
        }).sort((x, y) => x.label.localeCompare(y.label));

        setOptions(option);
    }

    useEffect(() => {
        try {
            require(`i18n-iso-countries/langs/${props.language}.json`);
            setOptions(undefined);
        } catch (e) {
            console.error('i18n-iso-countries is not available for: ' + props.language);
        }
    }, [props.language]);

    const onChange = (value) => {
        if (props.onChange) {
            props.onChange(props.id, value);
        }
    };

    return (
        <>
            {
                options &&
                <Dropdown options={options}  {...props} onChange={onChange}/>
            }
        </>
    );
};

CountrySelect.defaultProps = {
    language: 'de'
};

export default CountrySelect;
